import { paginationParams } from "@/utils/pagination";
import request from "@/utils/request";

export async function getAllCompanies({
  filter = "",
  autosledManager,
  name,
  city,
  flagStatus,
  sorting,
  page = 1,
  pageSize = 10,
  hasGroup,
}) {
  const { SkipCount, MaxResultCount } = paginationParams(page, pageSize);
  let Sorting;

  if (typeof sorting === "string" && sorting.indexOf(":") !== -1) {
    const [sortBy, sortOrder] = sorting.split(":");
    Sorting = `${sortBy} ${sortOrder}`;
  }

  const params = {
    FilterText: filter || undefined,
    ManagerId: autosledManager,
    City: city,
    Status: flagStatus,
    Name: name,

    Sorting,
    SkipCount,
    MaxResultCount,
  };

  if (hasGroup !== undefined) {
    params.HasGroup = hasGroup;
  }

  const result = request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/company`, {
    method: "GET",
    params,
  });

  return (await result).data;
}

export async function inviteUser(data) {
  const result = request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/company/invite`, {
    method: "POST",
    data,
  });
  return result;
}

export async function getCompaniesAllowed({ filter = "", sorting, page = 1, pageSize = 10 }) {
  const { SkipCount, MaxResultCount } = paginationParams(page, pageSize);
  let Sorting;

  if (typeof sorting === "string" && sorting.indexOf(":") !== -1) {
    const [sortBy, sortOrder] = sorting.split(":");
    Sorting = `${sortBy} ${sortOrder}`;
  }

  const params = {
    FilterText: filter || undefined,
    Sorting,
    SkipCount,
    MaxResultCount,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/company/allowed`, {
    method: "GET",
    params,
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result.data;
}

export async function changeCompanyOwner(companyId, data) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/company/owner/${companyId}`, {
    method: "PATCH",
    data,
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result?.response?.ok;
}
